import { useAuth0 } from '@auth0/auth0-react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link/Link';
import { observer } from 'mobx-react';
import React from 'react';
import { useStore } from '../../store/store';
import Container from '@mui/material/Container/Container';
import Box from '@mui/material/Box/Box';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import Typography from '@mui/material/Typography/Typography';
import styles from './NoAccess.module.css';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PhonelinkOffIcon from '@mui/icons-material/PhonelinkOff';
import GavelIcon from '@mui/icons-material/Gavel';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';

export default observer(function NoAccess() {
  const handleGoBack = () => {
    window.history.back();
  };

  const random = Math.floor(Math.random() * 4);

  switch (random) {
    case 0:
    default:
      return (
        <Container
          maxWidth='sm'
          sx={{
            textAlign: 'center',
            mt: 10,
            color: '#f5f0e6',
            p: 4,
            borderRadius: 2,
          }}
          className={styles.oneRing}
        >
          <DoNotDisturbAltIcon sx={{ fontSize: 100, color: '#6d4c41' }} />

          <Typography variant='h4' gutterBottom>
            🧙 Access Denied, Wanderer!
          </Typography>

          <Typography variant='body1' sx={{ mb: 2 }}>
            You have entered the realm of forbidden knowledge, guarded since the First Age.
          </Typography>

          <Typography variant='body1' sx={{ mb: 3 }}>
            None shall pass without the Rune of Admin Rights. Speak, friend, and go back. 🔒✨
          </Typography>

          <Button variant='outlined' sx={{ color: '#f5f0e6', borderColor: '#8d6e63' }} onClick={handleGoBack}>
            🧝‍♂️ Return to the Shire
          </Button>

          <Typography variant='caption' display='block' sx={{ mt: 2, color: '#c0bdb6ff' }}>
            (Your attempt has been etched into the Great Log of Denials.)
          </Typography>
        </Container>
      );

    case 1:
      return (
        <Container
          maxWidth='sm'
          sx={{
            textAlign: 'center',
            mt: 10,
            p: 4,
            color: '#fff8e1',
            borderRadius: 2,
          }}
          className={styles.archeology}
        >
          <GavelIcon sx={{ fontSize: 80, color: '#8d6e63' }} />

          <Typography variant='h4' gutterBottom>
            🏺 Access Denied!
          </Typography>

          <Typography variant='body1' sx={{ mb: 2 }}>
            You triggered a booby trap by trying to enter this page without the sacred amulet. 🧿
          </Typography>

          <Typography variant='body1' sx={{ mb: 3 }}>
            Legend says only those who “read the ancient JS scrolls” may pass. You didn’t read them. ⚠️📜
          </Typography>

          <Button variant='outlined' sx={{ color: '#fff8e1', borderColor: '#8d6e63' }} onClick={handleGoBack}>
            🏃 Flee the Temple!
          </Button>

          <Typography variant='caption' display='block' sx={{ mt: 2, color: '#c2bcabff' }}>
            (Seriously, turn around — the floor might collapse at any moment.)
          </Typography>
        </Container>
      );
    case 2:
      return (
        <Container
          maxWidth='sm'
          sx={{
            textAlign: 'center',
            mt: 10,
            p: 4,
            borderRadius: 2,
          }}
          className={styles.treckie}
        >
          <PhonelinkOffIcon sx={{ fontSize: 100, color: '#39ff14' }} />

          <Typography variant='h4' gutterBottom sx={{ mt: 2 }}>
            🖖 Access Denied: Starfleet Clearance Required
          </Typography>

          <Typography variant='body1' sx={{ mb: 2 }}>
            This section of the ship is restricted to officers with Level 10 clearance and a working tricorder.
          </Typography>

          <Typography variant='body1' sx={{ mb: 3 }}>
            Please retreat to a secure deck before the ship&apos;s AI logs this incursion. 🧠⚠️
          </Typography>

          <Button variant='outlined' sx={{ color: '#39ff14', borderColor: '#39ff14' }} onClick={handleGoBack}>
            🚀 Beam Me Back, Scotty!
          </Button>

          <Typography variant='caption' display='block' sx={{ mt: 2, color: '#888' }}>
            (Access attempt logged in the ship&apos;s star-date registry.)
          </Typography>
        </Container>
      );
    case 3:
      return (
        <Container
          maxWidth='sm'
          sx={{
            textAlign: 'center',
            mt: 10,
            p: 4,
            borderRadius: 2,
          }}
          className={styles.spacewars}
        >
          <WarningAmberIcon sx={{ fontSize: 100, color: '#ffe81f' }} />

          <Typography variant='h4' gutterBottom sx={{ mt: 2 }}>
            ⚠️ Galactic Access Denied!
          </Typography>

          <Typography variant='body1' sx={{ mb: 2 }}>
            This page is restricted to members of the Imperial Spatials and Certified Nerf-Herders only.
          </Typography>

          <Typography variant='body1' sx={{ mb: 3 }}>
            You&apos;ve attempted to bypass a Class-7 Security Field. Please return to your moisture farm. 🌌🚫
          </Typography>

          <Button variant='outlined' sx={{ color: '#ffe81f', borderColor: '#ffe81f' }} onClick={handleGoBack}>
            👣 Go Back Before the Council Notices
          </Button>

          <Typography variant='caption' display='block' sx={{ mt: 2, color: '#999' }}>
            The Force is not with you on this one. Try another hyperspace lane.
          </Typography>
        </Container>
      );
  }
});
